export class CompareToolBoxManager {
    constructor(parent, toolBoxManager) {
        this.parent = parent;
        this.toolBoxManager = toolBoxManager;
    }
    getOpenToolBoxStore() {
        return this.toolBoxManager.getOpenToolBoxStore();
    }
    getReferenceBranchIdStore() {
        return this.parent.getReferenceBranchIdStore();
    }
    getOtherScenariosStore() {
        return this.parent.getOtherScenariosStore();
    }
}
